import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';

interface LoadingButtonProps extends Omit<ButtonProps, 'loading'> {
	loading?: boolean;
}

export const LoadingButton: React.FC<LoadingButtonProps> = ({
	children,
	loading = false,
	disabled,
	startIcon,
	...props
}) => (
	<Button
		{...props}
		disabled={loading || disabled}
		startIcon={loading ? <CircularProgress size={20} color="inherit" /> : startIcon}
	>
		{children}
	</Button>
);
